var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ModulesState_1;
import { State, Store, Action, Selector, createSelector } from '@ngxs/store';
import { SaveModule, SaveModuleThumbnails, SaveModuleSuccess, SaveModuleFailure, ResetModules, SetSaveModule, GetModulePrimaryCategories, GetModuleSecondaryCategories, DuplicateModuleSuccess, DuplicateModuleFailure } from './modules.actions';
import { SerializeModuleService } from 'src/app/edit/serialize-module.service';
import { TrimConfiguration } from 'src/app/edit/models/trim-config.model';
import { ModulesService } from '../modules.service';
import { ModulesSaveResultEnum } from '../models/modules-save-result.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ModulesThumbnailService } from '../modules-thumbnail.service';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { forkJoin } from 'rxjs';
import { take, finalize } from 'rxjs/operators';
import { SaveModuleModel } from '../models/save-module.model';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { StoryService } from 'src/app/story/story.service';
import { SetStory, SetStoryId } from 'src/app/story/state/story.actions';
import { StoryState } from 'src/app/story/state/story.state';
const initialTrim = new TrimConfiguration();
initialTrim.graph.hidden = true;
const initialState = {
    primaryCategoryOptions: [],
    secondaryCategoryOptions: [],
    moduleExists: false,
    saveModule: new SaveModuleModel(),
    storyType: StoryType.Module,
    saving: false
};
let ModulesState = ModulesState_1 = class ModulesState {
    constructor(store, serializeModuleService, modulesService, modulesThumbnailService, storyService) {
        this.store = store;
        this.serializeModuleService = serializeModuleService;
        this.modulesService = modulesService;
        this.modulesThumbnailService = modulesThumbnailService;
        this.storyService = storyService;
    }
    static getSaveModule(state) {
        return state.saveModule;
    }
    static getPrimaryCategoryOptions(type) {
        return createSelector([ModulesState_1], (state) => {
            return (type === 'read') ?
                state.primaryCategoryOptions :
                state.primaryCategoryOptions.filter(value => value !== 'exports');
        });
    }
    static getSecondaryCategoryOptions(state) {
        return state.secondaryCategoryOptions;
    }
    static getSaving(state) {
        return state.saving;
    }
    saveModule(context, action) {
        context.patchState({ saving: true });
        // Prepare the save configurations
        const saveConfig = action.saveConfig;
        const trimConfig = action.trimConfig ? action.trimConfig : new TrimConfiguration();
        // Generate a new namespace map for the serialize object, included all child properties.
        // Then serialize the module.
        const namespaceMap = saveConfig.duplicate ? action.saveConfig.namespaceMap : {};
        // Pull the labels out of state and merge into the story before serialization
        const labels = this.store.selectSnapshot(StoryLabelsState.getLabels);
        const chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        this.storyService.storeLabelsInChapters(labels, chapters);
        const serialized = this.serializeModuleService.serialize(saveConfig.replace, namespaceMap, trimConfig, action.saveConfig.duplicate, this.store.selectSnapshot(StoryState.getStory), this.store.selectSnapshot(StoryChaptersState.getStoryChapters));
        // Save module file to the server.
        this.modulesService.saveModule(serialized.story, action.id)
            .pipe(finalize(() => context.patchState({ saving: false })))
            .subscribe((result) => {
            if (result === ModulesSaveResultEnum.Success) {
                if (serialized) {
                    this.store.dispatch(new SetStory(serialized.story));
                }
                this.store.dispatch(new SetStoryId(action.id));
                context.dispatch(new SaveModuleSuccess(action.id));
                // lazy save the thumbnails. 
                context.dispatch(new SaveModuleThumbnails(action.id, serialized, saveConfig));
            }
            else {
                context.dispatch(new SaveModuleFailure(action.id));
            }
        });
        // Duplicate module [working]
        if (saveConfig.duplicate) {
            const copyRequests$ = [];
            Object.entries(namespaceMap)
                .forEach(([sourceState, targetState]) => {
                copyRequests$.push(this.modulesService.copyState(sourceState, targetState));
            });
            forkJoin(copyRequests$)
                .subscribe((success) => {
                context.dispatch(new DuplicateModuleSuccess(action.id));
            }, (error) => {
                context.dispatch(new DuplicateModuleFailure(action.id));
            });
        }
    }
    // Send thumbnail data to server through thumbnail services
    // # FIXME: Work with @Brandon to support copying of thumbnails from module to module
    saveModuleThumbnails(context, action) {
        // const { serialized, moduleId, saveConfig } = context.getState();
        const thumbs = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
        // call service to save
        const indexId = action.serialized.story.chapters[0].id;
        this.modulesThumbnailService.saveStoryThumbnails({
            storyId: action.id,
            storyType: StoryType.Module,
            thumbnails: thumbs,
            chapterIdMap: action.serialized.chapterIdMap,
            indexId: indexId,
            deleteUnused: action.saveConfig.replace
        }).subscribe((success) => {
        });
    }
    setSaveModule(context, action) {
        context.patchState({
            saveModule: Object.assign({}, action.module)
        });
    }
    getModulePrimaryCategories(context, action) {
        this.modulesService.getPrimaryCategories()
            .subscribe((categories) => {
            context.patchState({
                primaryCategoryOptions: categories
            });
        });
    }
    getModuleSecondaryCategories(context, action) {
        this.modulesService.getSecondaryCategories(action.primaryCategory)
            .subscribe((categories) => {
            context.patchState({
                secondaryCategoryOptions: categories
            });
        });
    }
    // # TODO: Wire up full state reset, not just patchState
    resetModules(context, action) {
        forkJoin(this.modulesService.getPrimaryCategories(), this.modulesService.getSecondaryCategories(''))
            .pipe(take(1))
            .subscribe(([primaryCategories, secondaryCategories]) => {
            context.patchState({
                primaryCategoryOptions: primaryCategories,
                secondaryCategoryOptions: secondaryCategories
            });
        });
    }
};
__decorate([
    Action(SaveModule),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SaveModule]),
    __metadata("design:returntype", void 0)
], ModulesState.prototype, "saveModule", null);
__decorate([
    Action(SaveModuleThumbnails),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SaveModuleThumbnails]),
    __metadata("design:returntype", void 0)
], ModulesState.prototype, "saveModuleThumbnails", null);
__decorate([
    Action(SetSaveModule),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetSaveModule]),
    __metadata("design:returntype", void 0)
], ModulesState.prototype, "setSaveModule", null);
__decorate([
    Action(GetModulePrimaryCategories),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetModulePrimaryCategories]),
    __metadata("design:returntype", void 0)
], ModulesState.prototype, "getModulePrimaryCategories", null);
__decorate([
    Action(GetModuleSecondaryCategories),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetModuleSecondaryCategories]),
    __metadata("design:returntype", void 0)
], ModulesState.prototype, "getModuleSecondaryCategories", null);
__decorate([
    Action(ResetModules),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetModules]),
    __metadata("design:returntype", void 0)
], ModulesState.prototype, "resetModules", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ModulesState, "getSaveModule", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ModulesState, "getSecondaryCategoryOptions", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ModulesState, "getSaving", null);
ModulesState = ModulesState_1 = __decorate([
    State({
        name: 'modules',
        defaults: initialState
    }),
    __metadata("design:paramtypes", [Store,
        SerializeModuleService,
        ModulesService,
        ModulesThumbnailService,
        StoryService])
], ModulesState);
export { ModulesState };
